import { useTranslation } from "react-i18next";
import imgCompany from "../../assets/images/about-company.webp";
import imgCompetence from "../../assets/images/about-competence.webp";
import imgSolutions from "../../assets/images/about-solutions.webp";
import './about.scss';

const About: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="about" id="about">
            <div className="arg arg__company">
                <div className="arg__text ">
                    <h2 className="arg__header">{t("about.company.title")}</h2>
                    <p className="arg__p">{t("about.company.description")}</p>
                </div>
                <img src={imgCompany} alt="chip" className="arg__img" />
            </div>
            <div className="arg arg__competence">
                <div className="arg__text ">
                    <h2 className="arg__header">{t("about.competence.title")}</h2>
                    <p className="arg__p">{t("about.competence.description")}</p>
                </div>
                <img src={imgCompetence} alt="camera" className="arg__img" />
            </div>
            <div className="arg arg__solutions">
                <div className="arg__text">
                    <h2 className="arg__header">{t("about.solutions.title")}</h2>
                    <p className="arg__p">{t("about.solutions.description")}</p>
                </div>
                <img src={imgSolutions} alt="wire" className="arg__img" />
            </div>
        </section>
    )
}

export default About;
